import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { UserType } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';

@Component({
  selector: 'ds-codes-stds',
  templateUrl: './ds-codes-stds.component.html',
  styleUrls: ['./ds-codes-stds.component.css']
})
export class DsCodesStdsComponent implements OnInit, OnChanges {
  @Input() soLockObtained: boolean;
  @Input() accessLevel: Array<UserType>;  
  disableForm: boolean = false;
  inputDisableMessage: string = 'This form is not yet enabled';

  constructor(public _dataService: DataService) { }

  ngOnInit(): void {
  }
  ngOnChanges(): void {
    this.disableForm = true;
    if (this.soLockObtained == false) {
      this.inputDisableMessage = "You can't Edit";
    }
    else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
      // this.checkUserEnabled();
    }
  }

}

